import React, { useState } from "react";
import { GiHamburgerMenu } from "react-icons/gi";
import { AiOutlineClose } from "react-icons/ai";

const logoImg =
  "https://ubigro.com/wp-content/uploads/2021/06/UbiGro-Logo-black-on-white-04.png";

export default function NavBar() {
  const [open, setOpen] = useState(false);

  const toggleOpen = (props) => {
    setOpen(!open);
  };

  return (
    <div>
      <div id="navbar">
        <nav id="navlink">
          <div>
            <img id="ubiGroLogo" src={logoImg} alt="UbiGro Logo"></img>
          </div>
          <div className="HamburgerMenu">
            {open === true ? (
              <AiOutlineClose onClick={toggleOpen} />
            ) : (
              <GiHamburgerMenu onClick={toggleOpen} />
            )}
          </div>
          <div className="UbiGroLinks">
            <a
              className="UbiGroLink"
              href="https://ubigro.com/product/"
              target="_blank"
            >
              Product
            </a>
            <a
              className="UbiGroLink"
              href="https://ubigro.com/technology/"
              target="_blank"
            >
              Technology
            </a>
            <a
              className="UbiGroLink"
              href="https://ubigro.com/resources/"
              target="_blank"
            >
              Resources
            </a>
            <a
              className="UbiGroLink"
              href="https://ubigro.com/about-us/"
              target="_blank"
            >
              About Us
            </a>
            <a
              className="UbiGroLink"
              href="https://ubigro.com/contact-us/"
              target="_blank"
            >
              Contact Us
            </a>
          </div>
        </nav>
      </div>
      {open ? (
        <div className="UbiGroLinksSmall">
          <a
            className="UbiGroLink"
            href="https://ubigro.com/product/"
            target="_blank"
          >
            Product
          </a>
          <a
            className="UbiGroLink"
            href="https://ubigro.com/technology/"
            target="_blank"
          >
            Technology
          </a>
          <a
            className="UbiGroLink"
            href="https://ubigro.com/resources/"
            target="_blank"
          >
            Resources
          </a>
          <a
            className="UbiGroLink"
            href="https://ubigro.com/about-us/"
            target="_blank"
          >
            About Us
          </a>
          <a
            className="UbiGroLink"
            href="https://ubigro.com/contact-us/"
            target="_blank"
          >
            Contact Us
          </a>
        </div>
      ) : null}
    </div>
  );
}
